import { ModalsModule, Statuses, StatusesModule } from '@wix/domains-search-suite';
import { getPremiumEssentials } from '@wix/premium-fed-sdk/@premium-essentials';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { fetchWithFallback } from '@wix/premium-fed-sdk/@apis-infra';
import { EntriFlowStatus, parseDomain } from '@wix/domains-serverless-interface';
const {
  domainTakenInWix: domainTakenModal
} = ModalsModule.internals.domainsActionsModalsController;
const {
  loaderModal
} = ModalsModule.internals.domainsSharedModalsController;
const checkAccountLevelEligibility = async rootDomain => {
  const {
    httpClient
  } = getPremiumEssentials();
  loaderModal.show({});
  const [eligibility, canChangeOwnerRes] = await Promise.all([fetchWithFallback(DomainsApiClient.query.domainTakenInAnotherAccountEntriEligibility({
    httpClient: httpClient,
    request: {
      domain: rootDomain
    }
  }), {
    isEligible: false,
    domain: rootDomain
  }), fetchWithFallback(DomainsApiClient.query.canChangeDomainOwner({
    httpClient: httpClient,
    request: {
      domain: rootDomain
    }
  }), {
    canChangeOwner: false
  })]);
  loaderModal.hide();
  return {
    shouldOpenSiteSelector: eligibility.status === 'eligible_to_flow_account_level' || canChangeOwnerRes.status === 'can_change_owner_account_level'
  };
};
export const accountLevelStatusesOverrides = {
  transfer: Statuses.connect,
  domainTakenInWix: _ref => {
    let {
      domainName,
      actionHandler,
      externalViewer
    } = _ref;
    return {
      action: async () => {
        const {
          shouldOpenSiteSelector
        } = await checkAccountLevelEligibility(domainName ?? '');
        if (shouldOpenSiteSelector) {
          actionHandler == null || actionHandler({
            result: EntriFlowStatus.manual,
            domainName,
            externalViewer
          });
        } else {
          domainTakenModal.show({
            domain: domainName ?? ''
          });
        }
      },
      StatusComponent: StatusesModule.SDK.Components.DomainIsTaken
    };
  },
  subdomainTakenInWix: _ref2 => {
    let {
      domainName,
      actionHandler,
      externalViewer
    } = _ref2;
    const rootDomain = parseDomain(domainName ?? '').main;
    return {
      action: async () => {
        const {
          shouldOpenSiteSelector
        } = await checkAccountLevelEligibility(rootDomain);
        if (shouldOpenSiteSelector) {
          actionHandler == null || actionHandler({
            result: EntriFlowStatus.manual,
            externalViewer,
            domainName
          });
        } else {
          domainTakenModal.show({
            domain: rootDomain
          });
        }
      },
      StatusComponent: StatusesModule.SDK.Components.SubdomainRootIsTaken
    };
  }
};
//# sourceMappingURL=accountLevelStatusesOverrides.js.map